import React, { Component } from "react";
import { Container, Button, ModalFooter, ModalBody, Input } from "reactstrap";
import RequestManager from "../../singletons/RequestManager/RequestManager";
//import OrderStatusManager from "./OrderStatusManager";

// const orderStatusManager = new OrderStatusManager();
export default class ConfirmReject extends Component {
  constructor(props) {
    super(props);
    this.rejectText = "";
    this.state = {};
  }
  componentDidMount() {}
  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0, alignItems: "center" }}>
        <ModalBody>
          <h5 style={{ margin: 10 }}> Reject Order</h5>
        </ModalBody>
        <ModalFooter>
          <div>
            <Input
              type="text"
              placeholder="Enter reason for reject."
              onChange={(event) => {
                this.rejectText = event.target.value;
              }}
            />
            <Button
              color="danger"
              style={{
                margin: 10,
                paddingLeft: 25,
                paddingRight: 25,
              }}
              onClick={() => {
                this.props.goBack();
              }}
            >
              Cancel
            </Button>
            <Button
              color="success"
              style={{ paddingLeft: 25, margin: 10, paddingRight: 25 }}
              onClick={() => {
                if (this.rejectText.length > 1) {
                  this.updateSupportCommentsOrder();
                } else {
                  alert("Atleast one character should be their");
                }
              }}
            >
              Confirm
            </Button>
          </div>
        </ModalFooter>
      </Container>
    );
  }

  updateSupportCommentsOrder = async () => {
    let requestManager = new RequestManager();
    let comments = "";
    if (this.props.order && this.props.order.node.comments != null) {
      comments = this.props.order.node.comments;
    }
    let params = {
      input: {
        id: this.props.order.node.id,
        status: "REJECTED",
        comments:
          comments +
          this.props.storeInformation.store.name +
          ": " +
          this.rejectText,
      },
    };
    console.log("params11", JSON.stringify(params));
    let response = requestManager.getResponseFromPredefinedQuery(
      "updateOrder",
      params
    );
    console.log("updateOrder", JSON.stringify(response));
    this.props.toggleBackMain();
    this.props.goBack();
  };
}



// WEBPACK FOOTER //
// ./src/components/DetailedOrderCard/ConfirmReject.js